// SeatLayout.js
import React, { useState, useEffect } from "react";
import { Card, Modal, Button } from "react-bootstrap";
import "./seatbooking.css";
import { useDispatch, useSelector } from "react-redux";
import { loadSeatBookingGetDataRequest, loadSeatBookingAddDataRequest, loadSeatBookingCancelDataRequest,loadSeatBookingTimeSlotDataRequest} from "../redux/Actions";
import DefaultButton from "../../../shared/components/DefaultButton";
import layout from "../../../assets/Layout.png" // your layout image
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const SEAT_META = {
  available: { label: "Available", //icon: "fa-solid fa-circle"
    colorVar: "--seat-available",},
  booked: { label: "Reserved", //icon: "fa-solid fa-bookmark"
    colorVar: "--seat-available",},
  partiallybooked: { label: "Partially Reserved", //icon: "fa-solid fa-user" 
    colorVar: "--seat-available",
  },
  mybooked: { label: "My Reservation",// icon: "fa-solid fa-user"
    colorVar: "--seat-available",
   },
};

const normalizeSeats = (seats, emp_no, timeSlots) => {
  const map = {};

  seats.forEach(s => {
    const key = `${s.room}-${s.seat_number}`;

    if (!map[key]) {
      map[key] = {
        seat_id: s.seat_id,
        seat_number: s.seat_number,
        room: s.room,
        reservation_id: s.reservation_id,
        employee_id: s.employee_id,
        slots: {
          MORNING: null,
          EVENING: null,
        },
      };
    }

    if (!s.seat_status || s.seat_status === "available") return;

    const isMine = s.employee_id === emp_no;
    const name = s.full_name || "Unknown";
    const slotName = s.slot_name || "";

    // Map API time_slot_id → Morning / Evening / Full Day
    const slotMapping = {};
    timeSlots.forEach(slot => {
      const lower = slot.slot_name.toLowerCase();
      if (lower.includes("full")) slotMapping[slot.time_slot_id] = "FULL_DAY";
      else if (lower.includes("am") || lower.includes("morning")) slotMapping[slot.time_slot_id] = "MORNING";
      else slotMapping[slot.time_slot_id] = "EVENING";
    });

    const slotType = slotMapping[s.time_slot_id] || "EVENING";

    // Full day booking
    if (slotType === "FULL_DAY") {
      map[key].slots.MORNING = { employee: name, byMe: isMine, booked: true, time_slot_id: s.time_slot_id, reservation_id: s.reservation_id };
      map[key].slots.EVENING = { employee: name, byMe: isMine, booked: true, time_slot_id: s.time_slot_id, reservation_id: s.reservation_id };
      return;
    }

    // Partial booking
    if (slotType === "MORNING") {
      map[key].slots.MORNING = { employee: name, byMe: isMine, booked: true, time_slot_id: s.time_slot_id , reservation_id: s.reservation_id};
    } else if (slotType === "EVENING") {
      map[key].slots.EVENING = { employee: name, byMe: isMine, booked: true, time_slot_id: s.time_slot_id, reservation_id: s.reservation_id };
    }
  });

  return Object.values(map);
};



const SeatLayout = ({ seats, selectedDate, selectedFloor, disableBooking, onDateChange, minDate, maxDate}) => {
  const dispatch = useDispatch();
  const [selectedSeat, setSelectedSeat] = useState(null);
  const [originalDate, setOriginalDate] = useState(null); // Store original date when modal opens
  const emp_no = JSON.parse(localStorage.getItem("emp_no"));
  const employee = JSON.parse(localStorage.getItem("employee"));
  const emp_name = employee ? [employee.first_name, employee.last_name, employee.emp_no].filter(Boolean).join(", ") : "";
  const { seatBookingSuccess, cancelBookingSuccess, slots } = useSelector((state) => state.seatBooking);
  const displayDate = new Date(selectedDate + "T12:00:00");
  const getRoomLabel = (room) => {if (!room) return ""; return `Flex Room ${room.split("-")[1]}`; };
  const [showTodayModal, setShowTodayModal] = useState(false);
  const [todaySeat, setTodaySeat] = useState(null);
  const isToday = new Date(selectedDate).toDateString() === new Date().toDateString();
  const employeeReserved = seats.filter((s) => s.seat_status === "booked" && s.employee_id);
  const availableSeats = seats.filter((s) => s.seat_status === "available");
  const selectedDateObj = new Date(`${selectedDate}T12:00:00`);  // convert string → LOCAL date safely
  // const today = new Date();
  // const disableBooking = new Date(selectedDate) < today.setHours(0,0,0,0); // only past
  const normalizedSeats = normalizeSeats(seats, emp_no, slots); // pass slots from Redux
  const disableMorning = selectedSeat?.slots?.MORNING?.booked ?? false;
  const disableEvening = selectedSeat?.slots?.EVENING?.booked ?? false;
  const disableFullDay = disableMorning || disableEvening;
    const isMine = selectedSeat?.employee_id === emp_no;

    console.log("Ismine",isMine,seats.employee_id, emp_no );
    console.log("Slot",slots,"Seats", seats, "SelectedSeat",selectedSeat);
  


  useEffect(() => {
    dispatch(loadSeatBookingTimeSlotDataRequest());
  }, [dispatch])

  const handleReserve = () => {
    if (!selectedSeat?.time_slot_id) return;
    dispatch(
      loadSeatBookingAddDataRequest({
        seat_id: selectedSeat.seat_id,
        employee_id: emp_no,
        reservation_date: selectedDate,
        time_slot_id: selectedSeat.time_slot_id,
        purpose: "",
      })
    );
    closeModal();
  };


  const handleCancelReservation = () => {
    dispatch(loadSeatBookingCancelDataRequest(selectedSeat.reservation_id));
    closeModal();
  };

  const handleSeatClick = (seat) => {
    if (disableBooking) return;

    const morning = seat.slots.MORNING;
    const evening = seat.slots.EVENING;

    // Check if both slots are booked by others (not me)
    const morningBookedByOther = morning?.booked && !morning?.byMe;
    const eveningBookedByOther = evening?.booked && !evening?.byMe;

    // If both slots are fully booked by others, don't open modal
    if (morningBookedByOther && eveningBookedByOther) {
      return;
    }

    // If at least one slot is available or mine, open modal
    setSelectedSeat(seat);
  };

  const closeModal = () => setSelectedSeat(null);

  useEffect(() => {
    if (seatBookingSuccess || cancelBookingSuccess) {
      dispatch(
        loadSeatBookingGetDataRequest({
          date: selectedDate,
          floor_plan_id: selectedFloor,
        })
      );
    }
  }, [seatBookingSuccess, cancelBookingSuccess, dispatch]);

  const getSlotAvailability = (seatId) => {
  const seatBookings = seats.filter(s => s.seat_id === seatId);
  
  const availability = {};

  slots.forEach(slot => {
    // If this seat has a booking for this slot → disable it
    const hasBooked = seatBookings.some(
      s => s.seat_status === "booked" && s.time_slot_id === slot.time_slot_id
    );

    // If any "Full Day" slot is booked, all other slots are disabled
    const fullDaySlot = slots.find(s => s.slot_name.toLowerCase().includes("full day"));
    const fullDayBooked = fullDaySlot
      ? seatBookings.some(s => s.seat_status === "booked" && s.time_slot_id === fullDaySlot.time_slot_id)
      : false;

    availability[slot.time_slot_id] = hasBooked || fullDayBooked;
  });

  return availability;
};

    // Group all bookings for the same seat
    // const groupedSeats = seats.reduce((acc, s) => {
    //   const key = `${s.room}-${s.seat_number}`;
    //   if (!acc[key]) {
    //     acc[key] = { ...s, bookings: [] };
    //   }
    //   acc[key].bookings.push(s);
    //   return acc;
    // }, {});


  const changeDay = (delta) => {
    const d = new Date(selectedDateObj);
    d.setDate(d.getDate() + delta);
    onDateChange(d); // send Date object
  };

  const openTodayModal = () => {
    setOriginalDate(selectedDate); // Store current date before opening modal
    setShowTodayModal(true);
  };

  const closeTodayModal = () => {
    if (originalDate) {
      // Restore the original date from "Choose Date" picker
      onDateChange(new Date(originalDate + "T12:00:00"));
    }
    setShowTodayModal(false);
  };
  
  const getTooltipData = (seat, slots) => {
    const { MORNING, EVENING } = seat.slots;

    // Fully available
    if (!MORNING && !EVENING) return null;

    const items = [];

    // Helper function to get slot timing
    const getSlotTiming = (timeSlotId) => {
      const slot = slots.find(s => s.time_slot_id === timeSlotId);
      if (!slot) return "";
      
      // Extract timing from slot_name like "Morning (9:00 AM - 1:00 PM)"
      const match = slot.slot_name.match(/\(([^)]+)\)/);
      return match ? ` ${match[1]}` : "";
    };

    if (MORNING && EVENING) {
      if (MORNING.employee === EVENING.employee) {
        // Full day booked by same employee
        items.push(`${MORNING.employee} (Full Day)`);
      } else {
        // Partial by two employees
        const morningTiming = getSlotTiming(MORNING.time_slot_id);
        const eveningTiming = getSlotTiming(EVENING.time_slot_id);
        
        items.push(`${MORNING.employee} (Morning${morningTiming})`);
        items.push(`${EVENING.employee} (Evening${eveningTiming})`);
      }
    } else if (MORNING) {
      const morningTiming = getSlotTiming(MORNING.time_slot_id);
      items.push(`${MORNING.employee} (Morning${morningTiming})`);
    } else if (EVENING) {
      const eveningTiming = getSlotTiming(EVENING.time_slot_id);
      items.push(`${EVENING.employee} (Evening${eveningTiming})`);
    }

    return items;
  };


  return (
    <>
      <Card className="position-relative">
        <Card.Body>         

          {/* Date + Legend Row (Centered) */}
            <div className="d-flex justify-content-center align-items-center mb-3 gap-5">
              {/* Selected Date on the LEFT */}
              <div
                className="seat-date-header mb-0 seat-date-link"
                onClick={openTodayModal}
              >
                Seats for&nbsp;
                <span className="seat-date">
                  {displayDate?.toLocaleDateString("en-IN", {
                    weekday: "long",
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </span>
              </div>

          {/* Legend on the RIGHT */}
            <div className="seat-legend mb-0">
              {Object.entries(SEAT_META).map(([key, meta]) => (
                <div key={key} className="legend-item">
                  <span className={`legend-icon ${key}`} style={{ backgroundColor: meta.color }}>
                    <i className={meta.icon}></i>
                  </span>
                  <strong>{meta.label}</strong>
                </div>
              ))}
            </div>
          </div>

          {/* Date Picker Below Legends */}
          <div className="d-flex justify-content-center align-items-center mb-3">
            <div className="d-flex align-items-center gap-2">
              <strong className="text-nowrap">Choose Date:</strong>
              <DatePicker
                selected={displayDate}
                onChange={(date) => onDateChange(date)}
                dateFormat="MM-dd-yyyy"
                className="form-control"
                minDate={minDate}
                maxDate={maxDate}
                filterDate={(date) => {
                  const day = date.getDay();
                  return day !== 0 && day !== 6; // 0 = Sunday, 6 = Saturday
                }}
              />
              <div className="d-flex align-items-center gap-1 text-muted" style={{ fontSize: "0.75rem" }}>
                <i className="fa-solid fa-info-circle" style={{ color: "red" }}></i>
                <span className="text-nowrap">Select a date to view available seats</span>
              </div>
            </div>
          </div>

          {/* Hall layout */}
          <div className="hall-wrapper">
            <div className="hall-center-boxes">
              {["R-C", "R-D", "R-E"].map((roomKey) => (
                <div key={roomKey} className="hall-box">
                  <div className="hall-label">Flex Room {roomKey.slice(-1)}</div>
                  <div className={`room-seats room-${roomKey.slice(-1).toLowerCase()}`}>
                    {normalizedSeats
                      .filter(seat => seat.room === roomKey)
                      .map(seat => {
                        const morning = seat.slots.MORNING;
                        const evening = seat.slots.EVENING;

                        const fullyBooked = morning?.booked && evening?.booked;
                        const differentEmployees = fullyBooked && morning.employee !== evening.employee;
                        const partiallyBooked = (morning?.booked || false) !== (evening?.booked || false);

                        // Determine seat class
                            let seatClass = "available";

                            const morningBooked = morning?.booked;
                            const eveningBooked = evening?.booked;

                            // Both slots booked
                            if (morningBooked && eveningBooked) {
                              if (morning.employee === evening.employee) {
                                seatClass = morning.byMe ? "mybooked" : "booked"; // same person → full color
                              } else {
                                // Different employees → specify who booked which slot
                                if (morning.byMe) {
                                  seatClass = "partial both-booked-morning-me"; 
                                } else if (evening.byMe) {
                                  seatClass = "partial both-booked-evening-me"; 
                                } else {
                                  seatClass = "partial both-booked-neither"; 
                                }
                              }
                            }
                            // Only morning booked
                            else if (morningBooked && !eveningBooked) {
                              seatClass = morning.byMe ? "partial morning-mybooked" : "partial morning-booked";
                            }
                            // Only evening booked
                            else if (!morningBooked && eveningBooked) {
                              seatClass = evening.byMe ? "partial evening-mybooked" : "partial evening-booked";
                            }

                         const tooltipItems = seat.slots.MORNING || seat.slots.EVENING ? getTooltipData(seat, slots) : null;
                      return (
                      <div
                        key={`${seat.room}-${seat.seat_number}`}
                        className={`seat-cube ${seatClass}`}
                        onClick={() => handleSeatClick(seat)} 
                      >
                        {seat.seat_number}

                        {tooltipItems && (
                          <div className="seat-tooltip">
                            {tooltipItems.map((item, idx) => (
                              <div key={idx} className="tooltip-row">{item}</div>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                })}
                </div>
                </div>
              ))}
            </div>
          </div>

          {/* Information Text Below Desk Layout */}
          <div className="d-flex justify-content-center align-items-center mt-3">
            <div className="d-flex align-items-center gap-1" style={{ fontSize: "0.75rem", color: "red" }}>
              <strong>Note:</strong>
              <span>Seats may not be reserved more than 10 business days in advance.</span>
            </div>
          </div>
        </Card.Body>
      </Card>

      {/* Seat Booking Modal */}    
      <Modal show={!!selectedSeat} onHide={closeModal} centered size="md" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title className="d-flex flex-column">
            <span className="fw-bold">
              Reserve Seat - {getRoomLabel(selectedSeat?.room)} {selectedSeat?.seat_number}
            </span>              
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 seat-modal">
          {/* Date */}
          <div className="mb-3">
            <label className="form-label fw-semibold">Date</label>
            <input
              type="text"
              className="form-control"
              value={selectedDate}
              disabled
            />
          </div>
          
          {/* Duration */}
          <div className="mb-4">
            <label className="form-label fw-semibold">Duration</label>
            {selectedSeat && (
              <select
                className="form-select form-select-sm"
                value={selectedSeat.time_slot_id || ""}
                onChange={(e) =>
                  setSelectedSeat(prev => ({
                    ...prev,
                    time_slot_id: Number(e.target.value),
                  }))
                }
              >
                <option value="">Select time slot</option>
                {slots.map(slot => {
                  const name = slot.slot_name.toLowerCase();
                  const isMorning = name.includes("morning") || name.includes("am");
                  const isEvening = name.includes("evening") || name.includes("pm");
                  const isFullDay = name.includes("full");

                  // Check if this specific slot is booked by me
                  let isMySlot = false;
                  if (isMorning) {
                    isMySlot = selectedSeat.slots.MORNING?.byMe;
                  } else if (isEvening) {
                    isMySlot = selectedSeat.slots.EVENING?.byMe;
                  } else if (isFullDay) {
                    // Full day is only "my slot" if both morning AND evening have the SAME reservation_id
                    const morningResId = selectedSeat.slots.MORNING?.reservation_id;
                    const eveningResId = selectedSeat.slots.EVENING?.reservation_id;
                    isMySlot = selectedSeat.slots.MORNING?.byMe && 
                              selectedSeat.slots.EVENING?.byMe && 
                              morningResId === eveningResId &&
                              morningResId != null;
                  }

                  // Check if this slot is booked by someone else
                  let isBookedByOther = false;
                  if (isMorning) {
                    isBookedByOther = selectedSeat.slots.MORNING?.booked && !selectedSeat.slots.MORNING?.byMe;
                  } else if (isEvening) {
                    isBookedByOther = selectedSeat.slots.EVENING?.booked && !selectedSeat.slots.EVENING?.byMe;
                  } else if (isFullDay) {
                    // Disable full day if:
                    // 1. Either slot is booked by someone else, OR
                    // 2. Both slots are mine but with different reservation IDs (booked separately)
                    const morningResId = selectedSeat.slots.MORNING?.reservation_id;
                    const eveningResId = selectedSeat.slots.EVENING?.reservation_id;
                    const bothMineButDifferent = selectedSeat.slots.MORNING?.byMe && 
                                                selectedSeat.slots.EVENING?.byMe && 
                                                morningResId !== eveningResId;
                    
                    isBookedByOther = (selectedSeat.slots.MORNING?.booked && !selectedSeat.slots.MORNING?.byMe) || 
                                      (selectedSeat.slots.EVENING?.booked && !selectedSeat.slots.EVENING?.byMe) ||
                                      bothMineButDifferent;
                  }

                  // Only disable if booked by someone else or special full day case
                  const disabled = isBookedByOther;

                  return (
                    <option
                      key={slot.time_slot_id}
                      value={slot.time_slot_id}
                      disabled={disabled}
                    >
                      {slot.slot_name}{isMySlot ? " (Your Booking)" : ""}
                    </option>
                  );
                })}
              </select>
            )}
          </div>

          {/* Actions */}
          <div className="d-flex justify-content-end gap-3">
            <DefaultButton
              buttonClass="btn btn-secondary"
              buttonTitle="Cancel"
              buttonType="button"
              actionBlock={closeModal}
            />

            {/* Determine if selected slot is booked by me */}
            {(() => {
              if (!selectedSeat?.time_slot_id) return null;

              const selectedSlot = slots.find(s => s.time_slot_id === selectedSeat.time_slot_id);
              if (!selectedSlot) return null;

              const slotName = selectedSlot.slot_name.toLowerCase();
              const isMorning = slotName.includes("morning") || slotName.includes("am");
              const isEvening = slotName.includes("evening") || slotName.includes("pm");
              const isFullDay = slotName.includes("full");

              let isMyBooking = false;
              let reservationId = null;
              let isSlotAvailable = false;

              if (isFullDay) {
                // Full day - check if both slots are mine
                isMyBooking = selectedSeat.slots.MORNING?.byMe && selectedSeat.slots.EVENING?.byMe;
                reservationId = selectedSeat.slots.MORNING?.reservation_id || selectedSeat.slots.EVENING?.reservation_id;
                isSlotAvailable = !selectedSeat.slots.MORNING?.booked && !selectedSeat.slots.EVENING?.booked;
              } else if (isMorning) {
                isMyBooking = selectedSeat.slots.MORNING?.byMe;
                reservationId = selectedSeat.slots.MORNING?.reservation_id;
                isSlotAvailable = !selectedSeat.slots.MORNING?.booked;
              } else if (isEvening) {
                isMyBooking = selectedSeat.slots.EVENING?.byMe;
                reservationId = selectedSeat.slots.EVENING?.reservation_id;
                isSlotAvailable = !selectedSeat.slots.EVENING?.booked;
              }

              // Show Cancel Booking if this slot is mine
              if (isMyBooking && reservationId) {
                return (
                  <Button
                    variant="danger"
                    className="px-4"
                    onClick={() => {
                      dispatch(loadSeatBookingCancelDataRequest(reservationId));
                      closeModal();
                    }}
                  >
                    Cancel Booking
                  </Button>
                );
              }

              // Show Reserve button if slot is available (not booked by anyone)
              if (!disableBooking && isSlotAvailable) {
                return (
                  <DefaultButton
                    buttonClass="default-btn-color"
                    buttonTitle="Reserve Seat"
                    actionBlock={handleReserve}
                  />
                );
              }

              return null;
            })()}
          </div>
        </Modal.Body>
      </Modal>

    {/* Today Modal */}
      <Modal show={showTodayModal} onHide={closeTodayModal} centered size="lg">          
        <Modal.Header closeButton>
          <Modal.Title className="w-100">
            <div className="d-flex align-items-center justify-content-center gap-3">
              
              {/* Previous day */}
              <Button
                size="sm"
                variant="outline-secondary"
                onClick={() => changeDay(-1)}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </Button>

              {/* Selected date */}
              <span className="fw-semibold text-nowrap">
              {format(selectedDateObj, "dd MMM yyyy")}
              </span>

              {/* Next day */}
              <Button
                size="sm"
                variant="outline-secondary"
                onClick={() => changeDay(1)}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </Button>

            </div>
          </Modal.Title>
        </Modal.Header>  
        <Modal.Body style={{height: "650px", overflowY: "auto"}} className="p-4 seat-modal">
          {/* Column Headings */}
          <div className="row fw-bold text-uppercase mb-2 px-3">
            <div className="col-3">Seats</div>
            <div className="col-4">Employees</div>
            <div className="col-5">Duration</div>
          </div>

          {/* Group seats by unique seat_id and room */}
            {normalizedSeats.map((seat, index) => {
              // Check if seat has any bookings
              const morning = seat.slots.MORNING;
              const evening = seat.slots.EVENING;
              
              // Determine what to display
              let employeeDisplay = "-";
              let durationDisplay = "-";
              
              if (morning && evening) {
                if (morning.employee === evening.employee) {
                  // Full day by same person
                  employeeDisplay = morning.employee;
                  durationDisplay = "Full Day";
                } else {
                  // Different employees for morning/evening - show both with labels
                  employeeDisplay = (
                    <div className="d-flex flex-column">
                      <div>{morning.employee}</div>
                      <div> {evening.employee}</div>
                    </div>
                  );
                  durationDisplay = (
                    <div className="d-flex flex-column">
                      <div>
                        {slots.find(s => s.time_slot_id === morning.time_slot_id)?.slot_name || "Morning"}
                      </div>
                      <div>
                        {slots.find(s => s.time_slot_id === evening.time_slot_id)?.slot_name || "Evening"}
                      </div>
                    </div>
                  );
                }
              } else if (morning) {
                employeeDisplay = morning.employee;
                const morningSlot = slots.find(s => s.time_slot_id === morning.time_slot_id);
                durationDisplay = morningSlot?.slot_name || "Morning";
              } else if (evening) {
                employeeDisplay = evening.employee;
                const eveningSlot = slots.find(s => s.time_slot_id === evening.time_slot_id);
                durationDisplay = eveningSlot?.slot_name || "Evening";
              }
              
              return (
                <div
                  key={`${seat.seat_id}-${index}`}                  
                  className={`row align-items-center border-bottom px-3 py-2 ${seat.room}`}
                >
                  {/* Seat info */}
                  <div className="col-3">
                    <strong>{getRoomLabel(seat.room)}</strong><br />
                    <small>{seat.seat_number}</small>
                  </div>

                  {/* Employee name */}
                  <div className="col-4 text-muted">
                    {employeeDisplay}
                  </div>

                  {/* Duration */}
                  <div className="col-5">
                    <div className="d-flex flex-column">
                      <span className="fw-semibold" style={{fontSize: "0.9rem"}}>
                        {durationDisplay}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          {/* Show message if no seats at all */}
          {normalizedSeats.length === 0 && (
            <div className="text-center text-muted py-4">
              <i className="fa-solid fa-calendar-xmark fa-2x mb-2"></i>
              <p>No seats available</p>
            </div>
          )}
        </Modal.Body>
      </Modal>

    </>
  );
};

export default SeatLayout;
